import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';

import { useAccount } from 'shared/hooks/use-web3';
import { networkHandler } from 'shared/utils/networkHandler';

import LinkSvg from 'assets/link.svg?react';

import './LoaderHoc.scss';

interface ILoaderHocProps {
  messages?: string[];
  hash?: `0x${string}` | null | '';
  className?: string;
  children: React.ReactNode;
  selector?: string;
}

const LoaderHoc = ({ messages, className, children, hash, selector }: ILoaderHocProps) => {
  const { chainId } = useAccount();
  const { t } = useTranslation();
  const [currentMessage, setCurrentMessage] = useState(0);

  useEffect(() => {
    let interval: ReturnType<typeof setInterval>;
    if (messages && messages.length > 0) {
      interval = setInterval(() => {
        setCurrentMessage((prevMessage) => (prevMessage + 1) % messages.length);
      }, 10000);
    }
    return () => clearInterval(interval);
  }, [messages]);

  const content = (
    <div
      className={`relative flex w-[300px] flex-col items-center justify-center sm:w-[400px] ${
        className ? className : ''
      }`}
    >
      {children}
      {messages && messages.length > 0 && (
        <div>
          <div className="h-[2px] bg-loader-border" />
          <div className="flex flex-col items-center justify-center text-wrap bg-loader-content px-5 py-2 text-center sm:py-4">
            {hash && typeof hash === 'string' && (
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="flex justify-center text-md text-white sm:text-base"
                href={chainId && hash ? `${networkHandler(chainId)}/${hash}` : '#'}
              >
                <LinkSvg className="mr-2.5 h-[18px] w-4 text-white sm:h-[22px] sm:w-[22px]" />{' '}
                {t('common.transaction')}...
                {hash!.slice(-4)}
              </a>
            )}
            <span className="text-md text-white sm:text-base">{t(messages[currentMessage])}</span>
          </div>
          <div className="h-0.5 bg-loader-border" />
        </div>
      )}
    </div>
  );

  if (selector) {
    const portalRoot = document.querySelector(selector);
    if (portalRoot) {
      return ReactDOM.createPortal(content, portalRoot);
    }
  }

  return content;
};

export default LoaderHoc;
